import React from "react";
import styles from "./map.module.scss";
import { FaLocationDot } from "react-icons/fa6";

const Map = () => {
  return (
    <section className={styles.map_container}>
      <div className={styles.container}>
        <h1 className={styles.iframe_heading}> <FaLocationDot/> Corporate Office</h1>
        <div className={styles.container__}>
        <div className={styles.iframe__container}>
          <iframe 
            title="Map"
            width='100%'
            height='1000'
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3455.166104898725!2d31.426567275059757!3d30.003386520515747!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583dd17c7e5e69%3A0x5cae22227faed7c6!2sMILLENSYS%20Healthcare%20Solutions!5e0!3m2!1sen!2seg!4v1715041632586!5m2!1sen!2seg" 
            style={{border:'0'}} 
            allowfullscreen="" 
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            frameBorder='0'
            scrolling='no'
            marginheight='0'
            marginwidth='0'
            id='iFrameResizer0'
          >
          </iframe>
        </div>
        </div>
      </div>
    </section>
  );
};

export default Map;
